import type { FaireProductEntity } from "../../entity_types/product";

export const p_jebqb69vnw: FaireProductEntity = {
  token: "p_jebqb69vnw",
  type: "product",
  name: "MID WAISTED BIAS SKORT",
  brandToken: "b_q8gu9by5sv",
  brandName: "LE LIS",
  imageUrl:
    "https://cdn.faire.com/fastly/f4d4e4d7affa0961f4352d8f04c0e0b3c14d4b4d8ba5a1bb9f41a7125692fdfc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2c5b5bed611bb5fe134bd2c8dae15230902a9f846a14f4e96b76ec3878479ae3.jpeg",
    "https://cdn.faire.com/fastly/9cc3f817527b4ffe21690d70e4ef7a2c4074735306794c02b4ea111904da1130.jpeg",
    "https://cdn.faire.com/fastly/df0cfb70e8071466f4757d979e3c96f8dfc86133240ef9b545cd2682339ea498.jpeg",
    "https://cdn.faire.com/fastly/301d694cfc5bb9bd3bd40aaae8172a30b446ea6b24e77ebc438cc95c19c02171.jpeg",
    "https://cdn.faire.com/fastly/ea9e01c952dbf2a118017fdb75c94c293fab82e470be136000a73583e0aa7b83.jpeg",
    "https://cdn.faire.com/fastly/7dda5aaf3edc8bf76c43f20b332907c9c5248816ae2bb1da423af546a6a8c068.jpeg",
  ],
  priceDollars: 120,
  description:
    '**SKORT ONLY**\n\nMODEL IS WEARING A SIZE SMALL\n\nMODEL SPECS\nHEIGHT: 5\'8"\nBUST: 32B\nWAIST: 24"\nHIPS: 34"',
  tags: [],
  msrpDollars: 240,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:52:18.365Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
